import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body, #app {
    height: 100%;
  };

  [data-whatintent='mouse'] *:focus {
    outline: none !important;
  };

  ::-webkit-scrollbar {
    background: transparent;
    border: rgba(0, 0, 0, 0.2) solid;
  }

  ::-webkit-scrollbar:vertical {
    border-width: 0;
    width: 10px;
    background: #FCFCFC;
  }

  ::-webkit-scrollbar:horizontal {
    border-width: 0;
    height: 10px;
    background: #FCFCFC;
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }

  ::-webkit-scrollbar-thumb:active {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;
